import React from 'react'

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm">&copy; {new Date().getFullYear()} The Tech Nerd. All rights reserved.</p>
          </div>          

        </div>
      </div>
    </footer>
  )
}

export default Footer 